import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TermsOfServicePage = () => {
  return (
    <div className="container mx-auto py-8 px-4 max-w-4xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl">Terms of Service</CardTitle>
          <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        </CardHeader>
        <CardContent className="prose prose-sm max-w-none dark:prose-invert">
          <h2 className="text-2xl font-semibold mt-6 mb-3">1. Acceptance of Terms</h2>
          <p>By accessing and using TheSlice, you accept and agree to be bound by these Terms of Service.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">2. Use License</h2>
          <p>TheSlice grants you a personal, non-transferable license to use the platform for managing your professional athlete portfolio and related business activities.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">3. User Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">4. Prohibited Uses</h2>
          <ul>
            <li>Violating any applicable laws or regulations</li>
            <li>Infringing on intellectual property rights</li>
            <li>Transmitting malicious code or viruses</li>
            <li>Harassing or harming other users</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">5. Content Ownership</h2>
          <p>You retain ownership of all content you upload. By using TheSlice, you grant us a license to display and process your content to provide the service.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">6. Limitation of Liability</h2>
          <p>TheSlice is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">7. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Continued use constitutes acceptance of modified terms.</p>
          
          <h2 className="text-2xl font-semibold mt-6 mb-3">8. Contact</h2>
          <p>For questions about these Terms, please contact us at legal@theslice.com</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default TermsOfServicePage;
